import { render, staticRenderFns } from "./service-product.vue?vue&type=template&id=7a0e6e34&"
import script from "./service-product.vue?vue&type=script&lang=js&"
export * from "./service-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports